import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { DateUtils } from '@pbt/pbt-ui-components'

import EmailPreview from '~/components/common/emailPreview/EmailPreview'
import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'
import type { ChatMessage } from '~/types'

import MessageCardHeader from './MessageCardHeader'

const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: '100%',
    },
    messageContent: {
      position: 'relative',
    },
    header: {
      borderBottom: theme.constants.tableBorder,
    },
    previewContainerWrapper: {
      overflowX: 'auto',
      justifyContent: 'flex-start',
    },
    shadowDomPreviewContainer: {
      width: 240,
      overflowWrap: 'break-word',
    },
  }),
  { name: 'MessageCardMini' },
)

export interface MessageCardMiniProps {
  isPlainTextMessage?: boolean
  message: ChatMessage
}

const MessageCardMini = ({
  isPlainTextMessage = false,
  message,
}: MessageCardMiniProps) => {
  const classes = useStyles()
  const isCvcSystemMessageSuppressionEnabled = useSelector(
    getFeatureToggle(FeatureToggle.CVC_SYSTEM_MESSAGE_SUPPRESSION),
  )

  const isLoading = !message
  const { sendingDate, from, content, creator, isSystemMessage } = message

  const sendingTime = DateUtils.formatTime(sendingDate)
  const fromLabel = creator || from || ''

  return (
    <Grid className={classes.root}>
      <Grid container className={classes.header} px={2} py={1}>
        <MessageCardHeader
          isLoading={isLoading}
          isSystemMessage={
            isSystemMessage && isCvcSystemMessageSuppressionEnabled
          }
          sendingDateString={sendingTime}
          title={fromLabel}
        />
      </Grid>
      {content && (
        <Grid className={classes.messageContent} px={2} py={1}>
          <EmailPreview
            allowPointerEvents
            classes={{
              previewContainerWrapper: classes.previewContainerWrapper,
            }}
            disableHtmlRendering={isPlainTextMessage}
            emailPreviewShadowDomClasses={{
              previewContainer: classes.shadowDomPreviewContainer,
            }}
            emailTemplate={content}
            scale={1}
          />
        </Grid>
      )}
    </Grid>
  )
}

export default MessageCardMini
